import { render, staticRenderFns } from "./ComPierceAlert.vue?vue&type=template&id=35499400&scoped=true&"
import script from "./ComPierceAlert.vue?vue&type=script&lang=js&"
export * from "./ComPierceAlert.vue?vue&type=script&lang=js&"
import style0 from "./ComPierceAlert.vue?vue&type=style&index=0&id=35499400&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35499400",
  null
  
)

export default component.exports